import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NEW_DASHBOARD_TEMPLATE_ID } from "../constants";
var translation = /*#__PURE__*/_defineProperty({}, NEW_DASHBOARD_TEMPLATE_ID, {
  GENERAL_ERROR: 'Ocurrió un error',
  TRY_AGAIN: 'Vuelve a intentarlo',
  SEARCH_LABEL: '¿Qué buscas en tu panel?',
  INTERNET_CONNECTION_ERROR: 'Ocurrió un error de conexión',
  RELOAD_PAGE: 'Recargar la página',
  BUTTON_COLLAPSE_SIDEBAR_OPENED: 'Colapsar menu',
  BUTTON_COLLAPSE_SIDEBAR_CLOSED: 'Expandir menu',
  GO_TO_OLD_HOME_SNACKBAR_CTA: 'Volver a la versión antigua',
  PRODUCT: 'Producto'
});
export default translation;